import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as taskApi from '../../api/task';

// 获取任务列表
export const fetchTaskList = createAsyncThunk(
  'task/fetchTaskList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskList(params);
      
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务列表失败');
    }
  }
);

// 获取待审核任务列表
export const fetchPendingReviewTaskList = createAsyncThunk(
  'task/fetchPendingReviewTaskList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getPendingReviewTaskList(params);
      console.log("response",response)
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取待审核任务列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取待审核任务列表失败');
    }
  }
);

// 审核任务
export const reviewTask = createAsyncThunk(
  'task/reviewTask',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await taskApi.reviewTask(id, data);
      if (response && response.code === 200) {
        return response.data;
      }
      return rejectWithValue(response?.message || '审核任务失败');
    } catch (error) {
      return rejectWithValue(error.message || '审核任务失败');
    }
  }
);

// 获取任务状态变更历史列表
export const fetchTaskStatusHistoryList = createAsyncThunk(
  'task/fetchTaskStatusHistoryList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskStatusHistoryList(params);
      
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务状态变更历史列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务状态变更历史列表失败');
    }
  }
);

// 获取任务报名列表
export const fetchTaskSignupList = createAsyncThunk(
  'task/fetchTaskSignupList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskSignupList(params);
     
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务报名列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务报名列表失败');
    }
  }
);

// 获取用户报名历史列表
export const fetchTaskSignupHistoryList = createAsyncThunk(
  'task/fetchTaskSignupHistoryList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskSignupHistoryList(params);
     
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取用户报名历史列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取用户报名历史列表失败');
    }
  }
);

// 获取任务抢单列表
export const fetchTaskGrabList = createAsyncThunk(
  'task/fetchTaskGrabList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskGrabList(params);
      
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务抢单列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务抢单列表失败');
    }
  }
);

// 获取用户抢单历史列表
export const fetchTaskGrabHistoryList = createAsyncThunk(
  'task/fetchTaskGrabHistoryList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskGrabHistoryList(params);

      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取用户抢单历史列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取用户抢单历史列表失败');
    }
  }
);

// 获取任务录取列表
export const fetchTaskAdmissionList = createAsyncThunk(
  'task/fetchTaskAdmissionList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskAdmissionList(params);
      
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务录取列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务录取列表失败');
    }
  }
);

// 获取任务完成申请列表
export const fetchTaskCompletionApplyList = createAsyncThunk(
  'task/fetchTaskCompletionApplyList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskCompletionApplyList(params);
      
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务完成申请列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务完成申请列表失败');
    }
  }
);

// 获取任务完成申请历史列表
export const fetchTaskCompletionApplyHistoryList = createAsyncThunk(
  'task/fetchTaskCompletionApplyHistoryList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskCompletionApplyHistoryList(params);
      console.log("response",response)
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务完成申请历史列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务完成申请历史列表失败');
    }
  }
);

// 验收任务完成申请
export const verifyTaskCompletionApply = createAsyncThunk(
  'task/verifyTaskCompletionApply',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await taskApi.verifyTaskCompletionApply(id, data);
      if (response && response.code === 200) {
        return response.data;
      }
      return rejectWithValue(response?.message || '验收任务完成申请失败');
    } catch (error) {
      return rejectWithValue(error.message || '验收任务完成申请失败');
    }
  }
);

// 获取任务结算列表
export const fetchTaskSettlementList = createAsyncThunk(
  'task/fetchTaskSettlementList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskSettlementList(params);
      
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务结算列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务结算列表失败');
    }
  }
);

// 获取任务保证金账户列表
export const fetchTaskDepositList = createAsyncThunk(
  'task/fetchTaskDepositList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getTaskDepositList(params);
      console.log("response",response)
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取任务保证金账户列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取任务保证金账户列表失败');
    }
  }
);

// 获取保证金流水列表
export const fetchDepositTransactionList = createAsyncThunk(
  'task/fetchDepositTransactionList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getDepositTransactionList(params);
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取保证金流水列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取保证金流水列表失败');
    }
  }
);

// 获取保证金账户变更记录列表
export const fetchDepositChangeHistoryList = createAsyncThunk(
  'task/fetchDepositChangeHistoryList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await taskApi.getDepositChangeHistoryList(params);
      console.log("response",response)
      if (response && response.code === 200) {
        return {
          data: response.data,
          params: params
        };
      }
      return rejectWithValue(response?.message || '获取保证金账户变更记录列表失败');
    } catch (error) {
      return rejectWithValue(error.message || '获取保证金账户变更记录列表失败');
    }
  }
);

// 初始状态
const initialState = {
  // 任务列表
  taskList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 待审核任务列表
  pendingReviewTaskList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 任务审核状态
  reviewTaskStatus: {
    loading: false,
    success: false,
    error: null
  },
  // 任务状态变更历史列表
  taskStatusHistoryList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 任务报名列表
  taskSignupList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 用户报名历史列表
  taskSignupHistoryList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 任务抢单列表
  taskGrabList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 用户抢单历史列表
  taskGrabHistoryList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 任务录取列表
  taskAdmissionList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 任务完成申请列表
  taskCompletionApplyList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 任务完成申请历史列表
  taskCompletionApplyHistoryList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 验收任务完成申请状态
  verifyTaskCompletionApplyStatus: {
    loading: false,
    success: false,
    error: null
  },
  // 任务结算列表
  taskSettlementList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 任务保证金账户列表
  taskDepositList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  // 保证金流水列表
  depositTransactionList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  },
  
  // 保证金账户变更记录列表
  depositChangeHistoryList: {
    data: [],
    total: 0,
    loading: false,
    error: null,
    params: {
      pageNum: 1,
      pageSize: 10
    }
  }
};

// 创建slice
const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    // 清除任务审核状态
    clearReviewTaskStatus: (state) => {
      state.reviewTaskStatus = {
        loading: false,
        success: false,
        error: null
      };
    },
    // 清除验收任务完成申请状态
    clearVerifyTaskCompletionApplyStatus: (state) => {
      state.verifyTaskCompletionApplyStatus = {
        loading: false,
        success: false,
        error: null
      };
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理获取任务列表
      .addCase(fetchTaskList.pending, (state) => {
        state.taskList.loading = true;
        state.taskList.error = null;
      })
      .addCase(fetchTaskList.fulfilled, (state, action) => {
        state.taskList.loading = false;
        state.taskList.data = action.payload.data.records || [];
        state.taskList.total = action.payload.data.total || 0;
        state.taskList.params = action.payload.params;
      })
      .addCase(fetchTaskList.rejected, (state, action) => {
        state.taskList.loading = false;
        state.taskList.error = action.payload;
      })

      // 处理获取待审核任务列表
      .addCase(fetchPendingReviewTaskList.pending, (state) => {
        state.pendingReviewTaskList.loading = true;
        state.pendingReviewTaskList.error = null;
      })
      .addCase(fetchPendingReviewTaskList.fulfilled, (state, action) => {
        state.pendingReviewTaskList.loading = false;
        state.pendingReviewTaskList.data = action.payload.data.records || [];
        state.pendingReviewTaskList.total = action.payload.data.total || 0;
        state.pendingReviewTaskList.params = action.payload.params;
      })
      .addCase(fetchPendingReviewTaskList.rejected, (state, action) => {
        state.pendingReviewTaskList.loading = false;
        state.pendingReviewTaskList.error = action.payload;
      })

      // 处理审核任务
      .addCase(reviewTask.pending, (state) => {
        state.reviewTaskStatus.loading = true;
        state.reviewTaskStatus.success = false;
        state.reviewTaskStatus.error = null;
      })
      .addCase(reviewTask.fulfilled, (state) => {
        state.reviewTaskStatus.loading = false;
        state.reviewTaskStatus.success = true;
      })
      .addCase(reviewTask.rejected, (state, action) => {
        state.reviewTaskStatus.loading = false;
        state.reviewTaskStatus.error = action.payload;
      })

      // 处理获取任务状态变更历史列表
      .addCase(fetchTaskStatusHistoryList.pending, (state) => {
        state.taskStatusHistoryList.loading = true;
        state.taskStatusHistoryList.error = null;
      })
      .addCase(fetchTaskStatusHistoryList.fulfilled, (state, action) => {
        state.taskStatusHistoryList.loading = false;
        state.taskStatusHistoryList.data = action.payload.data.records || [];
        state.taskStatusHistoryList.total = action.payload.data.total || 0;
        state.taskStatusHistoryList.params = action.payload.params;
      })
      .addCase(fetchTaskStatusHistoryList.rejected, (state, action) => {
        state.taskStatusHistoryList.loading = false;
        state.taskStatusHistoryList.error = action.payload;
      })

      // 处理获取任务报名列表
      .addCase(fetchTaskSignupList.pending, (state) => {
        state.taskSignupList.loading = true;
        state.taskSignupList.error = null;
      })
      .addCase(fetchTaskSignupList.fulfilled, (state, action) => {
        state.taskSignupList.loading = false;
        state.taskSignupList.data = action.payload.data.records || [];
        state.taskSignupList.total = action.payload.data.total || 0;
        state.taskSignupList.params = action.payload.params;
      })
      .addCase(fetchTaskSignupList.rejected, (state, action) => {
        state.taskSignupList.loading = false;
        state.taskSignupList.error = action.payload;
      })
      
      // 处理获取用户报名历史列表
      .addCase(fetchTaskSignupHistoryList.pending, (state) => {
        state.taskSignupHistoryList.loading = true;
        state.taskSignupHistoryList.error = null;
      })
      .addCase(fetchTaskSignupHistoryList.fulfilled, (state, action) => {
        state.taskSignupHistoryList.loading = false;
        state.taskSignupHistoryList.data = action.payload.data.records || [];
        state.taskSignupHistoryList.total = action.payload.data.total || 0;
        state.taskSignupHistoryList.params = action.payload.params;
      })
      .addCase(fetchTaskSignupHistoryList.rejected, (state, action) => {
        state.taskSignupHistoryList.loading = false;
        state.taskSignupHistoryList.error = action.payload;
      })

      // 处理获取任务抢单列表
      .addCase(fetchTaskGrabList.pending, (state) => {
        state.taskGrabList.loading = true;
        state.taskGrabList.error = null;
      })
      .addCase(fetchTaskGrabList.fulfilled, (state, action) => {
        state.taskGrabList.loading = false;
        state.taskGrabList.data = action.payload.data.records || [];
        state.taskGrabList.total = action.payload.data.total || 0;
        state.taskGrabList.params = action.payload.params;
      })
      .addCase(fetchTaskGrabList.rejected, (state, action) => {
        state.taskGrabList.loading = false;
        state.taskGrabList.error = action.payload;
      })
      
      // 处理获取用户抢单历史列表
      .addCase(fetchTaskGrabHistoryList.pending, (state) => {
        state.taskGrabHistoryList.loading = true;
        state.taskGrabHistoryList.error = null;
      })
      .addCase(fetchTaskGrabHistoryList.fulfilled, (state, action) => {
        state.taskGrabHistoryList.loading = false;
        state.taskGrabHistoryList.data = action.payload.data.records || [];
        state.taskGrabHistoryList.total = action.payload.data.total || 0;
        state.taskGrabHistoryList.params = action.payload.params;
      })
      .addCase(fetchTaskGrabHistoryList.rejected, (state, action) => {
        state.taskGrabHistoryList.loading = false;
        state.taskGrabHistoryList.error = action.payload;
      })

      // 处理获取任务录取列表
      .addCase(fetchTaskAdmissionList.pending, (state) => {
        state.taskAdmissionList.loading = true;
        state.taskAdmissionList.error = null;
      })
      .addCase(fetchTaskAdmissionList.fulfilled, (state, action) => {
        state.taskAdmissionList.loading = false;
        state.taskAdmissionList.data = action.payload.data.records || [];
        state.taskAdmissionList.total = action.payload.data.total || 0;
        state.taskAdmissionList.params = action.payload.params;
      })
      .addCase(fetchTaskAdmissionList.rejected, (state, action) => {
        state.taskAdmissionList.loading = false;
        state.taskAdmissionList.error = action.payload;
      })

      // 处理获取任务完成申请列表
      .addCase(fetchTaskCompletionApplyList.pending, (state) => {
        state.taskCompletionApplyList.loading = true;
        state.taskCompletionApplyList.error = null;
      })
      .addCase(fetchTaskCompletionApplyList.fulfilled, (state, action) => {
        state.taskCompletionApplyList.loading = false;
        state.taskCompletionApplyList.data = action.payload.data.records || [];
        state.taskCompletionApplyList.total = action.payload.data.total || 0;
        state.taskCompletionApplyList.params = action.payload.params;
      })
      .addCase(fetchTaskCompletionApplyList.rejected, (state, action) => {
        state.taskCompletionApplyList.loading = false;
        state.taskCompletionApplyList.error = action.payload;
      })

      // 处理获取任务完成申请历史列表
      .addCase(fetchTaskCompletionApplyHistoryList.pending, (state) => {
        state.taskCompletionApplyHistoryList.loading = true;
        state.taskCompletionApplyHistoryList.error = null;
      })
      .addCase(fetchTaskCompletionApplyHistoryList.fulfilled, (state, action) => {
        state.taskCompletionApplyHistoryList.loading = false;
        state.taskCompletionApplyHistoryList.data = action.payload.data.records || [];
        state.taskCompletionApplyHistoryList.total = action.payload.data.total || 0;
        state.taskCompletionApplyHistoryList.params = action.payload.params;
      })
      .addCase(fetchTaskCompletionApplyHistoryList.rejected, (state, action) => {
        state.taskCompletionApplyHistoryList.loading = false;
        state.taskCompletionApplyHistoryList.error = action.payload;
      })

      // 处理验收任务完成申请
      .addCase(verifyTaskCompletionApply.pending, (state) => {
        state.verifyTaskCompletionApplyStatus.loading = true;
        state.verifyTaskCompletionApplyStatus.success = false;
        state.verifyTaskCompletionApplyStatus.error = null;
      })
      .addCase(verifyTaskCompletionApply.fulfilled, (state) => {
        state.verifyTaskCompletionApplyStatus.loading = false;
        state.verifyTaskCompletionApplyStatus.success = true;
      })
      .addCase(verifyTaskCompletionApply.rejected, (state, action) => {
        state.verifyTaskCompletionApplyStatus.loading = false;
        state.verifyTaskCompletionApplyStatus.error = action.payload;
      })

      // 处理获取任务结算列表
      .addCase(fetchTaskSettlementList.pending, (state) => {
        state.taskSettlementList.loading = true;
        state.taskSettlementList.error = null;
      })
      .addCase(fetchTaskSettlementList.fulfilled, (state, action) => {
        state.taskSettlementList.loading = false;
        state.taskSettlementList.data = action.payload.data.records || [];
        state.taskSettlementList.total = action.payload.data.total || 0;
        state.taskSettlementList.params = action.payload.params;
      })
      .addCase(fetchTaskSettlementList.rejected, (state, action) => {
        state.taskSettlementList.loading = false;
        state.taskSettlementList.error = action.payload;
      })

      // 处理获取任务保证金账户列表
      .addCase(fetchTaskDepositList.pending, (state) => {
        state.taskDepositList.loading = true;
        state.taskDepositList.error = null;
      })
      .addCase(fetchTaskDepositList.fulfilled, (state, action) => {
        state.taskDepositList.loading = false;
        state.taskDepositList.data = action.payload.data.records || [];
        state.taskDepositList.total = action.payload.data.total || 0;
        state.taskDepositList.params = action.payload.params;
      })
      .addCase(fetchTaskDepositList.rejected, (state, action) => {
        state.taskDepositList.loading = false;
        state.taskDepositList.error = action.payload;
      })

      // 处理获取保证金流水列表
      .addCase(fetchDepositTransactionList.pending, (state) => {
        state.depositTransactionList.loading = true;
        state.depositTransactionList.error = null;
      })
      .addCase(fetchDepositTransactionList.fulfilled, (state, action) => {
        state.depositTransactionList.loading = false;
        state.depositTransactionList.data = action.payload.data.records || [];
        state.depositTransactionList.total = action.payload.data.total || 0;
        state.depositTransactionList.params = action.payload.params;
      })
      .addCase(fetchDepositTransactionList.rejected, (state, action) => {
        state.depositTransactionList.loading = false;
        state.depositTransactionList.error = action.payload;
      })
      
      // 处理获取保证金账户变更记录列表
      .addCase(fetchDepositChangeHistoryList.pending, (state) => {
        state.depositChangeHistoryList.loading = true;
        state.depositChangeHistoryList.error = null;
      })
      .addCase(fetchDepositChangeHistoryList.fulfilled, (state, action) => {
        state.depositChangeHistoryList.loading = false;
        state.depositChangeHistoryList.data = action.payload.data.records || [];
        state.depositChangeHistoryList.total = action.payload.data.total || 0;
        state.depositChangeHistoryList.params = action.payload.params;
      })
      .addCase(fetchDepositChangeHistoryList.rejected, (state, action) => {
        state.depositChangeHistoryList.loading = false;
        state.depositChangeHistoryList.error = action.payload;
      })
  }
});

export const { clearReviewTaskStatus, clearVerifyTaskCompletionApplyStatus } = taskSlice.actions;

export default taskSlice.reducer; 